export const NotFoundMessage = ({ children }) => (
  <div className="not-found" style={{ marginTop: '20%' }}>
    <div className="card">
      <div className="card-body">{children}</div>
    </div>
  </div>
)
